/**
 * Adapptio Core Library
 *
 * @package lib-core
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { IDataSourceDefRegistry } from "../registries";
import { DataSourceVariable } from "./DataSourceVariable";
import { DataSourceAction } from "./DataSourceAction";
import { DataSourceConstant } from "./DataSourceConstant";
import { DataSourceMethod } from "./DataSourceMethod";
import { DataSourceContextProvider } from "./DataSourceContextProvider";
import { DataSourceContextConsumer } from "./DataSourceContextConsumer";
import { DataSourceWebSocketClient } from "./DataSourceWebSocketClient";
import { DataSourceTimer } from "./DataSourceTimer";

export * from "./DataSourceVariable";
export * from "./DataSourceConstant";
export * from "./DataSourceAction";
export * from "./DataSourceMethod";
export * from "./DataSourceContextProvider";
export * from "./DataSourceContextConsumer";
export * from './DataSourceVariable';
export * from './DataSourceAction';
export * from './DataSourceConstant';
export * from './DataSourceMethod';
export * from './DataSourceContextProvider';
export * from './DataSourceContextConsumer';
export * from './DataSourceWebSocketClient';
export * from './DataSourceTimer';

/**
 * Registers core data sources
 *
 * @param registry Data source definition registry
 */
export function registerCoreDataSources(registry: IDataSourceDefRegistry): void {
	registry.register(DataSourceVariable);
	registry.register(DataSourceConstant);
	registry.register(DataSourceAction);
	registry.register(DataSourceMethod);
	registry.register(DataSourceContextProvider);
	registry.register(DataSourceContextConsumer);
	registry.register(DataSourceWebSocketClient);
	registry.register(DataSourceTimer);
}
